import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import LandingSection from "./landingsection";
import { useState } from "react";
import { toast } from "react-toastify";
import { downloadFie } from "../lib/utils";

export default function AppsSection() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    const toastId = toast.loading("Downloading…");
    try {
      await downloadFie("Dannys.apk", "dannys.apk");

      toast.update(toastId, {
        render: "Download completed ✅",
        type: "success",
        isLoading: false,
        autoClose: 2500,
      });
    } catch {
      toast.update(toastId, {
        render: "Download failed ❌",
        type: "error",
        isLoading: false,
        autoClose: 2500,
      });
    } finally {
      setDownloading(false);
    }
  };
  return (
    <LandingSection
      title="Download Our Apps"
      description="Take the game room with you wherever you go"
    >
      <div
        id="mobile-app-section"
        className="flex flex-col sm:flex-row items-center justify-center gap-5"
      >
        {/* <button
          onClick={handleDownload}
          disabled={downloading}
          className="group relative bg-game-card border-2 border-game-border rounded-2xl px-8 py-3 w-full sm:w-auto min-w-[280px] transition-all duration-300 hover:border-game-cta hover:-translate-y-1 hover:shadow-xl hover:shadow-game-border/30"
        >
          <div className="flex items-center gap-4">
            <div className="text-5xl">
              <AndroidIcon sx={{ fontSize: 40, color: "green" }} />
            </div>
            <div className="text-left">
              <p className="text-sm text-gray-400 mb-1">Download on</p>
              <p className="text-xl font-bold text-white group-hover:text-game-cta transition-colors">
                Android
              </p>
            </div>
          </div>
        </button> */}
        {/* <a
          href="https://dannys-livechat.vercel.app/"
          rel="noreferrer"
          target="_blank"
          className="download-app-btn ml-auto px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md border-yellow-700 hover:brightness-110 transition flex items-center"
        >
          <FileDownloadOutlinedIcon className="mr-1 download-icon-animate" />
          Mobile Apps
        </a> */}
        {/* <a
          href="https://playground-one-lemon.vercel.app"
          target="_blank"
          className="group relative bg-game-card border-2 border-game-border rounded-2xl px-8 py-3 w-full sm:w-auto min-w-[280px] transition-all duration-300 hover:border-game-cta hover:-translate-y-1 hover:shadow-xl hover:shadow-game-border/30"
        > */}
        <a
          href="https://dannys-livechat.vercel.app/"
          rel="noreferrer"
          target="_blank"
          // className="download-app-btn ml-auto px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md border-yellow-700 hover:brightness-110 transition flex items-center"
          className="group relative bg-game-card border-2 border-game-border rounded-2xl px-8 py-3 w-full sm:w-auto min-w-[280px] transition-all duration-300 hover:border-game-cta hover:-translate-y-1 hover:shadow-xl hover:shadow-game-border/30"
        >
          <div className="flex items-center gap-4">
            {/* <div className="text-5xl">
              <AppleIcon sx={{ fontSize: 40 }} />
            </div> */}
            <div className="text-left">
              <p className="text-sm text-gray-400 mb-1">Download App</p>
              <p className="text-xl font-bold text-white group-hover:text-game-cta transition-colors">
                iOS/Android
              </p>
            </div>
          </div>
        </a>
      </div>
    </LandingSection>
  );
}
